<template>
  <div style="width:100%">
     <Loading :value="loading"></Loading>
     <h4 mt-3>LISTES DES RAPPORTS TRAVAUX</h4>
     <v-divider></v-divider>
     <v-layout wrap mt-3>
         <v-flex xs12 >
         <v-layout row class="mb-4 mt-1">
 
             <v-flex md4 class="mr-1">
               <el-select   filterable  @change="filtrerChantier()" v-model="chantierS" placeholder="Selectionner un Chantier" style="width:100%">
                   <el-option v-for="item in listeChantier" :key="item.id" :label="item.libelle" :value="item.id">
                   </el-option>
               </el-select>
             </v-flex>
 
              <v-flex md4 class="mr-1" v-if="chantierS != ''">
                     <el-select clearable   filterable  @change="filtrerTravaux()" v-model="travauxS" placeholder="Selectionner un travaux" style="width:100%">
                         <el-option v-for="item in listeTravaux" :key="item.idTravaux" :label="item.libTravaux" :value="item.idTravaux">
                         </el-option>
                     </el-select>
             </v-flex>
 
         </v-layout>
 
       </v-flex>
       <v-flex xs12 class="text-xs-right">
         <v-tooltip top>
           <v-btn slot="activator" icons color="primary" @click.stop="loadListerapports()" dark>
             Liste des rapports
             <v-icon right>assignment</v-icon>
           </v-btn>Liste des rapports
         </v-tooltip>
       </v-flex>
       <v-flex xs12 elevation-2 pt-3 pl-3>
         <data-tables ref="multipleTable" @selection-change="handleSelectionChange" :data="RapportTrx" style="width:99%;">
             <!--expand liste des journaux-->
               <el-table-column type="expand" v-if="typeInterface">
                 <template slot-scope="props">
                   <el-row class="elevation-3 pl-4 pr-4 pt-2">
                         <el-col :span="24">
                         <div class="grid-content bg-purple mb-2">                      
                             <div>
                               <data-tables
                                 ref="multipleTable"
                                 :data="props.row.journal"
                                 align="center"   
                                 style="width:100%"
                               >                                
                               <!-- <el-table-column prop="idRapport" label="RAPPORT" align="center">
                                 <template slot-scope="scope">ID-{{scope.row.idRapport}}</template>
                               </el-table-column> -->
                               <!-- <el-table-column prop="trancon" label="Trançon" align="center" width="300" fixed></el-table-column>                             -->
                               <el-table-column prop="dateRapport" label="Date" align="center" fixed></el-table-column>
                               <el-table-column prop="initiateur" label="INITIATEUR" align="center"></el-table-column>
                               <el-table-column prop="libEtat" label="ETAT" align="center" width="300">
                                 <template slot-scope="scope">
                                   <el-tag v-if="scope.row.etatRapport == 0" type="warning">{{scope.row.libEtat}}</el-tag>
                                   <el-tag v-if="scope.row.etatRapport == 1" type="info">{{scope.row.libEtat}}</el-tag>
                                   <el-tag v-if="scope.row.etatRapport == 2" type="success">{{scope.row.libEtat}}</el-tag>
                                   <el-tag v-if="scope.row.etatRapport == 3" type="danger">{{scope.row.libEtat}}</el-tag>
                                 </template>
                               </el-table-column>
                               <el-table-column  label="Action"  width="180" fixed="right">
                                   <template slot-scope="scope">
                                     <div class="text-xs-center">
                                       <v-tooltip top>
                                           <v-btn slot="activator" @click.stop="loadDetailRapport(scope.row)" flat dark small color="blue">
                                               Détails
                                           </v-btn>
                                           Détails
                                       </v-tooltip>
                                       <v-tooltip top v-if="scope.row.etatRapport !== 2">
                                           <v-btn slot="activator"  @click.stop="dialogSupr = true; IdRapport = scope.row;" flat dark small color="red">
                                             Supprimer
                                           </v-btn>
                                           Supprimer
                                       </v-tooltip>
                                     </div>
                                   </template>
                                 </el-table-column>
                               </data-tables>                                                                
                             </div>
                         </div>
                         </el-col>
                     </el-row>                                                                                                                      
                 </template>
               </el-table-column>
             <!--expand-->
 
           <el-table-column prop="idRapport" label="RAPPORT" width="90" align="center">
             <template slot-scope="scope">ID-{{scope.row.idRapport}}</template>
           </el-table-column>
           <el-table-column prop="libTrx" label="Travaux" align="center"></el-table-column>
           <el-table-column prop="dateRapport" width="100"  label="Date" align="center"></el-table-column>
           <el-table-column prop="initiateur" width="150" label="INITIATEUR" align="center"></el-table-column>
           <!-- <el-table-column prop="validChefChant" label="VALIDATION CHEF CHANTIER" align="center"></el-table-column>
           <el-table-column prop="validChefProjet" label="VALIDATION CHEF PROJET" align="center"></el-table-column> -->
           <el-table-column prop="libEtat" width="250" label="ETAT" align="center">
             <template slot-scope="scope">
               <el-tag v-if="scope.row.etatRapport == 0" type="warning">{{scope.row.libEtat}}</el-tag>
               <el-tag v-if="scope.row.etatRapport == 1" type="info">{{scope.row.libEtat}}</el-tag>
               <el-tag v-if="scope.row.etatRapport == 2" type="success">{{scope.row.libEtat}}</el-tag>
               <el-tag v-if="scope.row.etatRapport == 3" type="danger">{{scope.row.libEtat}}</el-tag>
             </template>
           </el-table-column>
           <el-table-column label="ACTION" align="center" width="200" fixed="right">
             <template slot-scope="scope">
               <v-tooltip bottom>
                 <v-btn
                   slot="activator"
                   @click="loadDetailGlobalRapport(scope.row)"
                   fab
                   dark
                   small
                   color="blue"
                 >
                   <v-icon dark>assignment</v-icon>
                 </v-btn>Detail rapport
               </v-tooltip>
               <v-tooltip top>
                 <v-btn v-if="scope.row.etatRapport !== 2" slot="activator" @click.stop="dialogSupr = true; IdRapport = scope.row;" fab dark small color="red">
                   <v-icon dark>delete</v-icon>
                 </v-btn>
                 Supprimer
               </v-tooltip>
             </template>
           </el-table-column>
         </data-tables>
       </v-flex>
     </v-layout>
     <!-- LISTE DES RAPPORTS RAPPORT -->
 
 
  <!-- MODAL SUPPRESSION -->
     <v-dialog v-model="dialogSupr" max-width="50%" :overlay="true" scrollable persistent>
       <v-card>
         <v-card-text text-xs-center>
           <h3 align="center">Voulez-vous vraiment supprimer cet rapport ?</h3>
           <p align="center">
             <v-btn @click.native="dialogSupr = false" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
             <v-btn icons color="red" @click.stop="deleteJournal" dark>Supprimer <v-icon right>delete</v-icon></v-btn>
           </p>
         </v-card-text>        
       </v-card>
     </v-dialog>
 
 
     <!-- DETAIL RAPPORT -->
     <v-dialog
       v-model="dialogDetailRapport"
       fullscreen
       hide-overlay
       transition="dialog-bottom-transition"
       scrollable
     >
       <v-card tile>
         <v-toolbar card dark color="primary">
           <v-toolbar-title>RAPPORT DE TRAVAUX {{detailRapport.libTrx}} N-{{detailRapport.idRapport}}</v-toolbar-title>
           <v-spacer></v-spacer>
           <v-btn icon dark @click.native="dialogDetailRapport = false">
             <v-icon>close</v-icon>
           </v-btn>
         </v-toolbar>
         <v-card-text>
           <v-layout row>
             <v-flex xs12>
               <v-card color class="mb-5" flat>
                 <v-layout wrap>
                   <v-flex xs12>
                     <v-alert
                       :value="true"
                       outline
                       color="purple"
                       icon="info"
                     >Informations générales sur le rapport</v-alert>
                     <v-card flat>
                       <v-layout wrap>
                         <v-card-text>
                           <v-flex xs12>
                             <v-flex xs12 class="text-xs-left">
                               <!--HAUT-->
                               <v-layout row>
                                 <v-flex xs6 class="mr-4">
                                   <!--COLONNE 1-->
                                   <v-layout row>
                                     <v-flex xs6>Date Rapport</v-flex>
                                     <v-flex
                                       xs6
                                       class="text-xs-right title"
                                     >{{detailRapport.dateRapport}}</v-flex>
                                   </v-layout>
                                   <v-divider class="mb-3"></v-divider>
 
                                   <v-layout row>
                                     <v-flex xs6>Température</v-flex>
                                     <v-flex xs6 class="text-xs-right title">{{detailRapport.temp}}</v-flex>
                                   </v-layout>
                                 
                                   <v-divider class="mb-3"></v-divider>
                                   <v-layout row>
                                     <v-flex xs6>Pluie</v-flex>
                                     <v-flex xs6 class="text-xs-right title">{{detailRapport.pluie}}</v-flex>
                                   </v-layout>
                                   <v-divider class="mb-3"></v-divider>
 
                                   <v-layout row>
                                     <v-flex xs6>Vent</v-flex>
                                     <v-flex xs6 class="text-xs-right title">{{detailRapport.vent}}</v-flex>
                                   </v-layout>
                                   <v-divider class="mb-3"></v-divider>
                                   <!-- <v-layout row>
                                     <v-flex xs6>Nombre d'heure de travail</v-flex>
                                     <v-flex xs6 class="text-xs-right title">{{detailRapport.nmbreHeur}}</v-flex>
                                   </v-layout> -->
                                   <!-- <v-divider class="mb-3"></v-divider>
                                   <v-layout row>
                                     <v-flex xs6>Trançon</v-flex>
                                     <v-flex
                                       xs6
                                       class="text-xs-right title"
                                     >{{detailRapport.trancon}}</v-flex>
                                   </v-layout>
                                   
                                   <v-divider class="mb-3"></v-divider>
 
                                   <v-layout row>
                                     <v-flex xs6>Du profil</v-flex>
                                     <v-flex
                                       xs6
                                       class="text-xs-right title"
                                     >{{detailRapport.profil}}</v-flex>
                                   </v-layout> -->
                                   <v-divider class="mb-3"></v-divider>
                                 </v-flex>
 
                                 <v-flex xs6 class="text-xs-left">
                                   <!--BAS-->
                                   <!-- <v-layout row>
                                     <v-flex xs6>Au profil</v-flex>
                                     <v-flex
                                       xs6
                                       class="text-xs-right title"
                                     >{{detailRapport.profil}}</v-flex>
                                   </v-layout> -->
                                   <v-divider class="mb-3"></v-divider>
                                   <v-layout row>
                                     <v-flex xs6>Etat</v-flex>
                                     <v-flex
                                       xs6
                                       class="text-xs-right title"
                                     >{{detailRapport.libEtat}}</v-flex>
                                   </v-layout>
                                   <v-divider class="mb-3"></v-divider>
                                   <v-layout row>
                                     <v-flex xs6>Initiateur</v-flex>
                                     <v-flex
                                       xs6
                                       class="text-xs-right title"
                                     >{{detailRapport.initiateur}}</v-flex>
                                   </v-layout>
                                   <v-divider class="mb-3"></v-divider>
                                   <v-layout row>
                                     <v-flex xs6>Date de création</v-flex>
                                     <v-flex xs6 class="text-xs-right title">{{detailRapport.dateC}}</v-flex>
                                   </v-layout>
                                   <v-divider class="mb-3"></v-divider>
                                   <v-layout row>
                                     <v-flex xs6>Projet</v-flex>
                                     <v-flex xs6 class="text-xs-right title">{{detailRapport.projet}}</v-flex>
                                   </v-layout>
                                   <v-divider class="mb-3"></v-divider>
                                   <v-layout row>
                                     <v-flex xs6>Chantier</v-flex>
                                     <v-flex
                                       xs6
                                       class="text-xs-right title"
                                     >{{detailRapport.chantier}}</v-flex>
                                   </v-layout>
                                   <v-divider class="mb-3"></v-divider>
                                 </v-flex>
                               </v-layout>
                             </v-flex>
                           </v-flex>
                         </v-card-text>
                       </v-layout>
                     </v-card>
                   </v-flex>
 
                   <v-flex xs12>
                     <v-alert :value="true" outline color="purple" icon="info">TRAVAUX REALISES</v-alert>
                     <v-card color class="mb-5">
                       <v-card-text>
                         <v-layout wrap>
                           <v-flex xs12>
                             <v-card class="pt-2">
                               <h4>LISTE DES TACHES</h4>
                               <v-divider></v-divider>
                               <v-layout wrap>
                                 <v-flex xs12 mt-2>
                                   <el-table :data="detailRapport.listeTaches" style="width: 100%">
                                     <el-table-column type="expand">
                                       <template slot-scope="props">
                                         <p>
                                           <b>Commentaire</b>
                                           : {{ props.row.commentaire }}
                                         </p>
                                       </template>
                                     </el-table-column>
 
                                     <el-table-column prop="libTache" label="Libelle" sortable></el-table-column>
                                     <el-table-column v-if="soustraitant == 'OUI'" prop="soustraitant" label="Sous-traitant" sortable></el-table-column>
                                     <el-table-column prop="qte" label="Quantité"></el-table-column>
                                     <el-table-column prop="unite" label="Unité"></el-table-column>
                                     <el-table-column prop="libEtatTache" label="Etat"></el-table-column>
                                    <el-table-column prop="photos" label="Images">
                                       <template slot-scope="props">
                                           <v-tooltip bottom>
                                           <v-avatar
                                                   slot="activator"
                                                   v-for="(image, imageIndex) in props.row.photos"
                                                   :key="imageIndex"
                                                   @click="showDiapo(props.row.photos,imageIndex ,image)"
                                                   :style="{ backgroundImage: 'url(' + image + ')' , cursor: 'pointer'}"
                                                   :tile=true
                                                   :size="50"
                                                   color="grey lighten-4"
                                                   class="mb-1 mr-1 elevation-3"
                                           >
                                               <img :src="image" alt="avatar">
                                           </v-avatar>
                                               Cliquez pour agrandir
                                           </v-tooltip>
                                       </template>
                                     </el-table-column>
                                     <el-table-column>
                                       <template slot-scope="props">
                                         <v-tooltip bottom>
                                           <v-btn
                                             v-if="verifValideChefChant() || verifValideChefProjet()"
                                             @click.stop="showDialogReserve(props.row)"
                                             slot="activator"
                                             icons
                                             color="orange"
                                             fab
                                             dark
                                             small
                                           >
                                             <v-icon>add</v-icon>
                                           </v-btn>
                                           <span>Créer une réserve</span>
                                         </v-tooltip>
                                       </template>
                                     </el-table-column>
                                   </el-table>
                                 </v-flex>
                               </v-layout>
                               <br />
                             </v-card>
                           </v-flex>
                         </v-layout>
                       </v-card-text>
                     </v-card>
                   </v-flex>
 
                   <v-flex xs12 v-if="detailRapport.listeReserves.length > 0">
                     <v-alert :value="true" outline color="purple" icon="info">TRAVAUX DE RESERVE {{detailRapport.listeVehicules}}</v-alert>
                     <v-card color class="mb-5">
                       <v-card-text>
                         <v-layout wrap>
                           <v-flex xs12>
                             <v-card class="pt-2">
                               <h4>LISTE DES TRAVAUX DE RESERVE</h4>
                               <v-divider></v-divider>
                               <v-layout row mt-3>
                                 <v-flex xs12>
                                   <data-tables :data="detailRapport.listeReserves" style="width:99%;">
                                     <el-table-column type="expand">
                                       <template slot-scope="scope">
                                         <el-row>
                                           <el-col :span="8">
                                             <div class="grid-content bg-purple">
                                               <h2 class="mb-2">Commentaires:</h2>
                                               <div
                                                 class="mb-2"
                                                 v-for="(com, i) in scope.row.commentaires"
                                                 :key="i"
                                               >
                                                 <h3>Initiateur: {{com.initiateur}}</h3>
                                                 <h4>Date: {{com.dateCom}}</h4>
                                                 <h4>Description:</h4>
                                                 <div>{{com.description}}</div>
                                               </div>
                                             </div>
                                           </el-col>
 
                                           <el-col :span="14">
                                             <h2 class="mb-2">Photos:</h2>
                                             <p>
                                               <span
                                                 v-for="(photo, index) in scope.row.photos"
                                                 :key="index"
                                               >
                                                 <v-avatar
                                                   class="mr-2"
                                                   :tile="true"
                                                   size="140px"
                                                   height="120px"
                                                   color="grey lighten-4"
                                                 >
                                                   <img :src="photo" alt="avatar" />
                                                 </v-avatar>
                                               </span>
                                             </p>
                                           </el-col>
                                         </el-row>
                                       </template>
                                     </el-table-column>
 
                                     <el-table-column prop="idReserve" label="RESERVE" sortable>
                                       <template slot-scope="scope">R-{{scope.row.idReserve}}</template>
                                     </el-table-column>
                                     <el-table-column prop="dateC" label="DATE" sortable></el-table-column>
                                     <el-table-column prop="libTache" label="TACHE"></el-table-column>
                                     <el-table-column prop="etatReserve" label="ETAT">
                                       <template slot-scope="scope">
                                         <el-tag v-if="scope.row.etatReserve == 0" type="warning">{{scope.row.libEtatRes}}</el-tag>
                                         <el-tag v-if="scope.row.etatReserve == 1" type="info">{{scope.row.libEtatRes}}</el-tag>
                                         <el-tag v-if="scope.row.etatReserve == 2" type="success">{{scope.row.libEtatRes}}</el-tag>
                                         <el-tag v-if="scope.row.etatReserve == 3" type="danger">{{scope.row.libEtatRes}}</el-tag>
                                       </template>
                                     </el-table-column>
                                     <el-table-column prop="initiateur" label="INITIATEUR"></el-table-column>
                                     <el-table-column prop="validateur" label="VALIDATEUR"></el-table-column>
 
                                     <el-table-column prop="cout" label="MONTANT"></el-table-column>
                                     <el-table-column prop="dureeRetard" label="DUREE RETARD (J)"></el-table-column>
                                   </data-tables>
                                 </v-flex>
                               </v-layout>
                               <br />
                             </v-card>
                           </v-flex>
                         </v-layout>
                       </v-card-text>
                     </v-card>
                   </v-flex>
 
                   <v-flex xs12>
                     <v-alert :value="true" outline color="purple" icon="info">INCIDENTS</v-alert>
                     <v-card color class="mb-5">
                       <v-card-text>
                         <v-layout wrap>
                           <v-flex xs12>
                             <v-card class="pt-2">
                               <h4>LISTE DES INCIDENTS</h4>
                               <v-divider></v-divider>
                               <v-layout row>
                                 <el-table :data="detailRapport.incidents" style="width: 100%">
                                   <el-table-column type="expand">
                                     <template slot-scope="props">
                                       <p>
                                         <b>Description</b>
                                         : {{ props.row.description }}
                                       </p>
                                     </template>
                                   </el-table-column>
                                   <el-table-column prop="libelle" label="Libelle" sortable></el-table-column>
                                   <el-table-column prop="type" label="Type"></el-table-column>
                                   <el-table-column prop="qte" label="Quantité"></el-table-column>
                                   <el-table-column prop="date" label="Date et heure"></el-table-column>
                                 </el-table>
                               </v-layout>
                                <v-alert v-if="detailRapport.incidents.length == 0" class="elevation-1 subheading mb-1" color="warning" :value="true" icon="priority_high" outline>
                                     Informations non renseignées lors de l'enregistrement du rapport
                                 </v-alert>
                               <br />
                             </v-card>
                           </v-flex>
                         </v-layout>
                       </v-card-text>
                     </v-card>
                   </v-flex>
 
                   <v-flex xs12>
                     <v-alert :value="true" outline color="purple" icon="info">VISITEUR CHANTIER</v-alert>
                     <v-card color class="mb-5">
                       <v-card-text>
                         <v-layout wrap>
                           <v-flex xs12>
                             <v-card class="pt-2">
                               <h4>LISTE DES VISITEURS</h4>
                               <v-divider></v-divider>
                               <v-layout row>
                                 <el-table :data="detailRapport.listeVisiteurs" style="width: 100%">
                                   <el-table-column prop="nomPrenom" label="Nom & Prénoms" sortable></el-table-column>
                                   <el-table-column prop="fonction" label="Fonction"></el-table-column>
                                   <el-table-column prop="dateVisite" label="Date de visite"></el-table-column>
                                   <el-table-column prop="HeureDbut" label="Heure debut"></el-table-column>
                                   <el-table-column prop="HeureFin" label="Heure debut"></el-table-column>
                                 </el-table>
                               </v-layout>
                                <v-alert v-if="detailRapport.listeVisiteurs.length == 0" class="elevation-1 subheading mb-1" color="warning" :value="true" icon="priority_high" outline>
                                     Informations non renseignées lors de l'enregistrement du rapport
                                 </v-alert>
                               <br />
                             </v-card>
                           </v-flex>
                         </v-layout>
                       </v-card-text>
                     </v-card>
                   </v-flex>
 
                   <v-flex xs12>
                     <v-alert :value="true" outline color="purple" icon="info">INVENTAIRE DES RESSOURCES </v-alert>
                     <v-card color class="mb-5">
                       <v-card-text>
                         <v-layout wrap>
                           <v-flex xs12>
                             <v-card class="pt-2">
                               <h4>LISTE DES RESSOURCES UTILISEES</h4>
                               <v-divider></v-divider>
                               <v-layout row>
                                 <el-table :data="detailRapport.listeMateriels" style="width: 100%">
                                   <el-table-column prop="libMat" label="Ressources" sortable></el-table-column>
                                   <el-table-column prop="qteMat" label="Quantité"></el-table-column>
                                   <el-table-column prop="unite" label="Unité"></el-table-column>
                                 </el-table>
                               </v-layout>
                                <v-alert v-if="detailRapport.listeMateriels.length == 0" class="elevation-1 subheading mb-1" color="warning" :value="true" icon="priority_high" outline>
                                     Informations non renseignées lors de l'enregistrement du rapport
                                 </v-alert>
                               <br />
                             </v-card>
                           </v-flex>
                         </v-layout>
                       </v-card-text>
                     </v-card>
                   </v-flex>
 
                   <v-flex xs12 v-if="false">
                     <v-alert :value="true" outline color="purple" icon="info">INVENTAIRE DES RESSOURCES EXTERNES</v-alert>
                     <v-card color class="mb-5">
                       <v-card-text>
                         <v-layout wrap>
                           <v-flex xs12>
                             <v-card class="pt-2">
                               <h4>LISTE DES RESSOURCES EXTERNES UTILISEES</h4>
                               <v-divider></v-divider>
                                 <br/>
                                 <div v-if="detailRapport.listeExterneMateriels.length > 0">
                                      <v-layout wrap>
                                   <v-flex md10>
                                       <v-chip outline text-color="primary" label color="primary" style="font-size:33px; width:100%">
                                           TOTAL TRAVAIL : {{totalExterniHT}}
                                       </v-chip>
                                   </v-flex>
                               </v-layout>
                                 </div>
                               <v-layout row>
                                 <el-table :data="detailRapport.listeExterneMateriels" style="width: 100%">
                                   <el-table-column prop="type" label="Type" sortable></el-table-column>
                                   <el-table-column prop="libelle" label="Libelle"></el-table-column>
                                   <el-table-column prop="qte" label="Quantité " sortable></el-table-column>
                                   <el-table-column prop="unite" label="Unité" sortable></el-table-column>
                                   <el-table-column prop="heureDebut" label="Heure debut"></el-table-column>
                                   <el-table-column prop="heureFin" label="Heure fin"></el-table-column>                  
                                   <!-- <el-table-column prop="cout" label="Montant dépensé(FCFA)"></el-table-column> -->
                                 </el-table>
                               </v-layout>
                                <v-alert v-if="detailRapport.listeExterneMateriels.length == 0" class="elevation-1 subheading mb-1" color="warning" :value="true" icon="priority_high" outline>
                                     Informations non renseignées lors de l'enregistrement du rapport
                                 </v-alert>
                               <br />
                             </v-card>
                           </v-flex>
                         </v-layout>
                       </v-card-text>
                     </v-card>
                   </v-flex>
 
 
                   <v-flex xs12>
                     <v-alert :value="true" outline color="purple" icon="info">UTILISATION DES MATERIELS/ENGINS UTILISES</v-alert>
                     <v-card color class="mb-5">
                       <v-card-text>
                         <v-layout wrap>
                           <v-flex xs12>
                             <v-card class="pt-2">
                               <h4>LISTE DES MATERIELS/ENGINS UTILISES</h4>
                               <v-divider></v-divider>
                                 <br/>
                                 <div v-if="detailRapport.listeVehicules.length > 0">
                                      <v-layout wrap>
                                   <v-flex md10>
                                       <v-chip outline text-color="primary" label color="primary" style="font-size:33px; width:100%">
                                           TOTAL TRAVAIL : {{totalVehiHT}}
                                       </v-chip>
                                   </v-flex>
                                   <v-flex md10>
                                       <v-chip outline text-color="primary" label color="primary" style="font-size:33px; width:100%">
                                           TOTAL QUANTITE CARBURANT : {{ new Intl.NumberFormat('fr-Fr').format(totalQteCarb)}} LITRE(S)
                                       </v-chip>
                                   </v-flex>
                               </v-layout>
                                 </div>
                               <v-layout row>
                                 <el-table :data="detailRapport.listeVehicules" style="width: 100%">
                                     <el-table-column type="expand">
                                       <template slot-scope="props">
                                          <p>
                                           <b>Compteur début jour(km)</b>
                                           : {{ props.row.cptDjour }}
                                         </p>
                                          <p>
                                           <b>Compteur fin jour(km)</b>
                                           : {{ props.row.cptFjour }}
                                         </p>
                                         <p>
                                           <b>Prix (L)  du  carburant (FCFA)</b>
                                           : {{ props.row.cout }}
                                         </p>                                        
                                         <p>
                                           <b>Fournisseur</b>
                                           : {{ props.row.fournisseur }}
                                         </p>
                                         <p>
                                           <b>Description</b>
                                           : {{ props.row.description }}
                                         </p>
                                       </template>
                                   </el-table-column>
                                   <el-table-column prop="libelle" label="Matériel/Engin" sortable></el-table-column>
                                   <el-table-column prop="heureDebut" label="Heure début"></el-table-column>
                                   <el-table-column prop="heureFin" label="Heure fin"></el-table-column>
                                   <el-table-column prop="heurePause" label="Heure pause"></el-table-column>
                                   <el-table-column prop="heureTotal" label="Heure total"></el-table-column>
                                   <el-table-column prop="qte" label="Quantité Carburant(L)" sortable></el-table-column>
                                   <el-table-column prop="utilisation" label="Côut horaire(FCFA)"> </el-table-column>
                                 </el-table>
                               </v-layout>
                                <v-alert v-if="detailRapport.listeVehicules.length == 0" class="elevation-1 subheading mb-1" color="warning" :value="true" icon="priority_high" outline>
                                     Informations non renseignées lors de l'enregistrement du rapport
                                 </v-alert>
                               <br />
                             </v-card>
                           </v-flex>
                         </v-layout>
                       </v-card-text>
                     </v-card>
                   </v-flex>
 
                   <v-flex xs12>
                     <v-alert :value="true" outline color="purple" icon="info">LISTE DES RESSOURCES TECHNIQUES</v-alert>
                     <v-card color class="mb-5">
                       <v-card-text>
                         <v-layout wrap>
                           <v-flex xs12>
                             <v-card class="pt-2">
                               <h4>LISTE DES RESSOURCES TECHNIQUES UTILISEES</h4>
                               <v-divider></v-divider>
                                <br/>
                                <v-layout row>
                                 <el-table
                                   :data="detailRapport.listeRessourtechnik"
                                   style="width: 100%"
                                 >
                                   <el-table-column prop="fonction" label="Fonction" sortable></el-table-column>
                                   <el-table-column prop="nombre" label="Nombre" sortable></el-table-column>
                                 </el-table>
                               </v-layout>
                                <v-alert v-if="detailRapport.listeRessourtechnik.length == 0" class="elevation-1 subheading mb-1" color="warning" :value="true" icon="priority_high" outline>
                                     Informations non renseignées lors de l'enregistrement du rapport
                                 </v-alert>
                               <br />
                             </v-card>
                           </v-flex>
                         </v-layout>
                       </v-card-text>
                     </v-card>
                   </v-flex>
                 </v-layout>
               </v-card>
             </v-flex>
           </v-layout>
         </v-card-text>
 
          <CoolLightBox :items="items" :index="index" @close="index = null">
             </CoolLightBox>
 
         <!-- VALIDATION -->
         <div style="flex: 1 1 auto;"></div>
       </v-card>
       <v-tooltip top>
         <v-btn
           class="mb-5 ml-5"
           v-if="verifValideChefProjet()"
           absolute
           slot="activator"
           dark
           fab
           large
           bottom
           right
           color="green"
           @click="dialogValidRapport = true"
         >
           <v-icon>done</v-icon>
         </v-btn>
         <span>Valider la demande chef projet</span>
       </v-tooltip>
 
       <v-tooltip top>
         <v-btn
           class="mb-5 ml-5"
           v-if="verifValideChefChant()"
           absolute
           slot="activator"
           dark
           fab
           large
           bottom
           right
           color="purple"
           @click="dialogValidRapport = true"
         >
           <v-icon>done</v-icon>
         </v-btn>
         <span>Valider la demande chef chantier</span>
       </v-tooltip>
 
       <v-tooltip top>
         <v-btn
           class="ml-5"
           style="margin-bottom: 140px;"
           absolute
           slot="activator"
           dark
           fab
           large
           bottom
           right
           color="orange"
           @click="imprimeJournalPDF()"
         >
           <v-icon>print</v-icon>
         </v-btn>
         <span>Imprimer le rapport</span>
       </v-tooltip>
 
 
     </v-dialog>
     <!-- DETAIL RAPPORT -->
 
      <!-- DETAIL RAPPORT -->
      <v-dialog
       v-model="dialogDetailGblobalRapport"
       fullscreen
       hide-overlay
       transition="dialog-bottom-transition"
       scrollable
     >
       <v-card tile>
         <v-toolbar card dark color="primary">
           <v-toolbar-title>RAPPORT ID-{{detailRapport.idRapport}} DE TRAVAUX DU {{detailRapport.dateRapport}} : {{detailRapport.libTrx}}</v-toolbar-title>
           <v-spacer></v-spacer>
           <v-btn icon dark @click.native="dialogDetailGblobalRapport = false">
             <v-icon>close</v-icon>
           </v-btn>
         </v-toolbar>
         <v-card-text>
           <v-layout row>
             <v-flex xs12>
               <v-card color class="mb-5" flat>
                 <v-layout wrap>
                   <v-flex xs12>
                     <v-alert
                       :value="true"
                       outline
                       color="purple"
                       icon="info"
                     >Informations générales sur le rapport</v-alert>
                     <v-card flat>
                       <v-layout wrap>
                         <v-card-text>
                           <v-flex xs12>
                             <v-flex xs12 class="text-xs-left">
                               <!--HAUT-->                  
                               <v-layout row>
                                 <v-flex xs6 class="mr-4">
                                   <!--COLONNE 1-->  
                                   <v-layout row>
                                     <v-flex xs3>Date de création</v-flex>
                                     <v-flex xs9 class="text-xs-right title">{{detailRapport.dateC}}</v-flex>
                                   </v-layout>                              
                                   <v-divider class="mb-3"></v-divider>
                                   <v-layout row>
                                     <v-flex xs2>Etat</v-flex>
                                     <v-flex
                                       xs10
                                       class="text-xs-right title"
                                     >{{detailRapport.libEtat}}</v-flex>
                                   </v-layout>
                                   <v-divider class="mb-3"></v-divider>
                                 </v-flex>
 
                                 <v-flex xs6 class="text-xs-left">
                                   <!--BAS-->
                                   <v-layout row>
                                     <v-flex xs3>Projet</v-flex>
                                     <v-flex xs9 class="text-xs-right title">{{detailRapport.projet}}</v-flex>
                                   </v-layout>
                                   <v-divider class="mb-3"></v-divider>
                                   <v-layout row>
                                     <v-flex xs3>Chantier</v-flex>
                                     <v-flex
                                       xs9
                                       class="text-xs-right title"
                                     >{{detailRapport.chantier}}</v-flex>
                                   </v-layout>
                                   <v-divider class="mb-3"></v-divider>
                                   <v-layout row>
                                     <v-flex xs6>Travaux</v-flex>
                                     <v-flex
                                       xs6
                                       class="text-xs-right title"
                                     >{{detailRapport.libTrx}}</v-flex>
                                   </v-layout>
                                 </v-flex>
                             <v-divider></v-divider>
                               </v-layout>
                                    <v-layout row>
                                     <el-table :data="detailRapport.listeRapport" align="center" style="width:100%">            
                                       <!-- <el-table-column prop="trancon" label="Trançon" align="center" width="300" fixed></el-table-column>                             -->
                                       <el-table-column prop="dateRapport" label="Date" align="center" fixed></el-table-column>
                                       <el-table-column prop="initiateur" label="INITIATEUR" align="center"></el-table-column>
                                       <el-table-column prop="libEtat" label="ETAT" align="center" width="300">
                                       <template slot-scope="scope">
                                         <el-tag v-if="scope.row.etatRapport == 0" type="warning">{{scope.row.libEtat}}</el-tag>
                                         <el-tag v-if="scope.row.etatRapport == 1" type="info">{{scope.row.libEtat}}</el-tag>
                                         <el-tag v-if="scope.row.etatRapport == 2" type="success">{{scope.row.libEtat}}</el-tag>
                                         <el-tag v-if="scope.row.etatRapport == 3" type="danger">{{scope.row.libEtat}}</el-tag>
                                       </template>
                               </el-table-column>
                                     </el-table>                                                              
                               </v-layout>
                             </v-flex>
                           </v-flex>
                         </v-card-text>
                       </v-layout>
                     </v-card>
                   </v-flex>
 
                   <v-flex xs12>
                     <v-alert :value="true" outline color="purple" icon="info">TRAVAUX REALISES</v-alert>
                     <v-card color class="mb-5">
                       <v-card-text>
                         <v-layout wrap>
                           <v-flex xs12>
                             <v-card class="pt-2">
                               <h4>LISTE DES TACHES</h4>
                               <v-divider></v-divider>
                               <v-layout wrap>
                                 <v-flex xs12 mt-2>
                                   <el-table :data="detailRapport.listeTaches" style="width: 100%">
                                     <el-table-column type="expand">
                                       <template slot-scope="props">
                                         <p>
                                           <b>Commentaire</b>
                                           : {{ props.row.commentaire }}
                                         </p>
                                       </template>
                                     </el-table-column>
 
                                     <el-table-column prop="libTache" label="Libelle" sortable></el-table-column>
                                     <el-table-column v-if="soustraitant == 'OUI'" prop="soustraitant" label="Sous-traitant" sortable></el-table-column>
                                     <el-table-column prop="qte" label="Quantité"></el-table-column>
                                     <el-table-column prop="unite" label="Unité"></el-table-column>
                                     <el-table-column prop="libEtatTache" label="Etat"></el-table-column>
                                    <el-table-column prop="photos" label="Images">
                                       <template slot-scope="props">
                                           <v-tooltip bottom>
                                           <v-avatar
                                                   slot="activator"
                                                   v-for="(image, imageIndex) in props.row.photos"
                                                   :key="imageIndex"
                                                   @click="showDiapo(props.row.photos,imageIndex ,image)"
                                                   :style="{ backgroundImage: 'url(' + image + ')' , cursor: 'pointer'}"
                                                   :tile=true
                                                   :size="50"
                                                   color="grey lighten-4"
                                                   class="mb-1 mr-1 elevation-3"
                                           >
                                               <img :src="image" alt="avatar">
                                           </v-avatar>
                                               Cliquez pour agrandir
                                           </v-tooltip>
 
 
                                         <!-- <span
                                           v-for="(photo, index) in props.row.photos"
                                           :key="index"
                                         >
                                           <v-avatar
                                             class="mr-2"
                                             :tile="true"
                                             size="100px"
                                             height="100px"
                                             color="grey lighten-4"
                                           >
                                             <img :src="photo" alt="avatar" />
                                           </v-avatar>
                                         </span> -->
                                       </template>
                                     </el-table-column>
                                     <el-table-column>
                                       <template slot-scope="props">
                                         <v-tooltip bottom>
                                           <v-btn
                                             v-if="verifValideChefChant() || verifValideChefProjet()"
                                             @click.stop="showDialogReserve(props.row)"
                                             slot="activator"
                                             icons
                                             color="orange"
                                             fab
                                             dark
                                             small
                                           >
                                             <v-icon>add</v-icon>
                                           </v-btn>
                                           <span>Créer une réserve</span>
                                         </v-tooltip>
                                       </template>
                                     </el-table-column>
                                   </el-table>
                                 </v-flex>
                               </v-layout>
                               <br />
                             </v-card>
                           </v-flex>
                         </v-layout>
                       </v-card-text>
                     </v-card>
                   </v-flex>
 
                   <v-flex xs12 v-if="detailRapport.listeReserves.length > 0">
                     <v-alert :value="true" outline color="purple" icon="info">TRAVAUX DE RESERVE {{detailRapport.listeVehicules}}</v-alert>
                     <v-card color class="mb-5">
                       <v-card-text>
                         <v-layout wrap>
                           <v-flex xs12>
                             <v-card class="pt-2">
                               <h4>LISTE DES TRAVAUX DE RESERVE</h4>
                               <v-divider></v-divider>
                               <v-layout row mt-3>
                                 <v-flex xs12>
                                   <data-tables :data="detailRapport.listeReserves" style="width:99%;">
                                     <el-table-column type="expand">
                                       <template slot-scope="scope">
                                         <el-row>
                                           <el-col :span="8">
                                             <div class="grid-content bg-purple">
                                               <h2 class="mb-2">Commentaires:</h2>
                                               <div
                                                 class="mb-2"
                                                 v-for="(com, i) in scope.row.commentaires"
                                                 :key="i"
                                               >
                                                 <h3>Initiateur: {{com.initiateur}}</h3>
                                                 <h4>Date: {{com.dateCom}}</h4>
                                                 <h4>Description:</h4>
                                                 <div>{{com.description}}</div>
                                               </div>
                                             </div>
                                           </el-col>
 
                                           <el-col :span="14">
                                             <h2 class="mb-2">Photos:</h2>
                                             <p>
                                               <span
                                                 v-for="(photo, index) in scope.row.photos"
                                                 :key="index"
                                               >
                                                 <v-avatar
                                                   class="mr-2"
                                                   :tile="true"
                                                   size="140px"
                                                   height="120px"
                                                   color="grey lighten-4"
                                                 >
                                                   <img :src="photo" alt="avatar" />
                                                 </v-avatar>
                                               </span>
                                             </p>
                                           </el-col>
                                         </el-row>
                                       </template>
                                     </el-table-column>
 
                                     <el-table-column prop="idReserve" label="RESERVE" sortable>
                                       <template slot-scope="scope">R-{{scope.row.idReserve}}</template>
                                     </el-table-column>
                                     <el-table-column prop="dateC" label="DATE" sortable></el-table-column>
                                     <el-table-column prop="libTache" label="TACHE"></el-table-column>
                                     <el-table-column prop="etatReserve" label="ETAT">
                                       <template slot-scope="scope">
                                         <el-tag v-if="scope.row.etatReserve == 0" type="warning">{{scope.row.libEtatRes}}</el-tag>
                                         <el-tag v-if="scope.row.etatReserve == 1" type="info">{{scope.row.libEtatRes}}</el-tag>
                                         <el-tag v-if="scope.row.etatReserve == 2" type="success">{{scope.row.libEtatRes}}</el-tag>
                                         <el-tag v-if="scope.row.etatReserve == 3" type="danger">{{scope.row.libEtatRes}}</el-tag>
                                       </template>
                                     </el-table-column>
                                     <el-table-column prop="initiateur" label="INITIATEUR"></el-table-column>
                                     <el-table-column prop="validateur" label="VALIDATEUR"></el-table-column>
 
                                     <el-table-column prop="cout" label="MONTANT"></el-table-column>
                                     <el-table-column prop="dureeRetard" label="DUREE RETARD (J)"></el-table-column>
                                   </data-tables>
                                 </v-flex>
                               </v-layout>
                               <br />
                             </v-card>
                           </v-flex>
                         </v-layout>
                       </v-card-text>
                     </v-card>
                   </v-flex>
 
                   <v-flex xs12>
                     <v-alert :value="true" outline color="purple" icon="info">INCIDENTS</v-alert>
                     <v-card color class="mb-5">
                       <v-card-text>
                         <v-layout wrap>
                           <v-flex xs12>
                             <v-card class="pt-2">
                               <h4>LISTE DES INCIDENTS</h4>
                               <v-divider></v-divider>
                               <v-layout row>
                                 <el-table :data="detailRapport.incidents" style="width: 100%">
                                   <el-table-column type="expand">
                                     <template slot-scope="props">
                                       <p>
                                         <b>Description</b>
                                         : {{ props.row.description }}
                                       </p>
                                     </template>
                                   </el-table-column>
                                   <el-table-column prop="libelle" label="Libelle" sortable></el-table-column>
                                   <el-table-column prop="type" label="Type"></el-table-column>
                                   <el-table-column prop="qte" label="Quantité"></el-table-column>
                                   <el-table-column prop="date" label="Date et heure"></el-table-column>
                                 </el-table>
                               </v-layout>
                                <v-alert v-if="detailRapport.incidents.length == 0" class="elevation-1 subheading mb-1" color="warning" :value="true" icon="priority_high" outline>
                                     Informations non renseignées lors de l'enregistrement du rapport
                                 </v-alert>
                               <br />
                             </v-card>
                           </v-flex>
                         </v-layout>
                       </v-card-text>
                     </v-card>
                   </v-flex>
 
                   <v-flex xs12>
                     <v-alert :value="true" outline color="purple" icon="info">VISITEUR CHANTIER</v-alert>
                     <v-card color class="mb-5">
                       <v-card-text>
                         <v-layout wrap>
                           <v-flex xs12>
                             <v-card class="pt-2">
                               <h4>LISTE DES VISITEURS</h4>
                               <v-divider></v-divider>
                               <v-layout row>
                                 <el-table :data="detailRapport.listeVisiteurs" style="width: 100%">
                                   <el-table-column prop="nomPrenom" label="Nom & Prénoms" sortable></el-table-column>
                                   <el-table-column prop="fonction" label="Fonction"></el-table-column>
                                   <el-table-column prop="dateVisite" label="Date de visite"></el-table-column>
                                   <el-table-column prop="HeureDbut" label="Heure debut"></el-table-column>
                                   <el-table-column prop="HeureFin" label="Heure debut"></el-table-column>
                                 </el-table>
                               </v-layout>
                                <v-alert v-if="detailRapport.listeVisiteurs.length == 0" class="elevation-1 subheading mb-1" color="warning" :value="true" icon="priority_high" outline>
                                     Informations non renseignées lors de l'enregistrement du rapport
                                 </v-alert>
                               <br />
                             </v-card>
                           </v-flex>
                         </v-layout>
                       </v-card-text>
                     </v-card>
                   </v-flex>
 
                   <v-flex xs12>
                     <v-alert :value="true" outline color="purple" icon="info">INVENTAIRE DES RESSOURCES </v-alert>
                     <v-card color class="mb-5">
                       <v-card-text>
                         <v-layout wrap>
                           <v-flex xs12>
                             <v-card class="pt-2">
                               <h4>LISTE DES RESSOURCES UTILISEES</h4>
                               <v-divider></v-divider>
                               <v-layout row>
                                 <el-table :data="detailRapport.listeMateriels" style="width: 100%">
                                   <el-table-column prop="libMat" label="Ressources" sortable></el-table-column>
                                   <el-table-column prop="qteMat" label="Quantité"></el-table-column>
                                   <el-table-column prop="unite" label="Unité"></el-table-column>
                                 </el-table>
                               </v-layout>
                                <v-alert v-if="detailRapport.listeMateriels.length == 0" class="elevation-1 subheading mb-1" color="warning" :value="true" icon="priority_high" outline>
                                     Informations non renseignées lors de l'enregistrement du rapport
                                 </v-alert>
                               <br />
                             </v-card>
                           </v-flex>
                         </v-layout>
                       </v-card-text>
                     </v-card>
                   </v-flex>
 
                   <v-flex xs12>
                     <v-alert :value="true" outline color="purple" icon="info">INVENTAIRE DES RESSOURCES EXTERNES</v-alert>
                     <v-card color class="mb-5">
                       <v-card-text>
                         <v-layout wrap>
                           <v-flex xs12>
                             <v-card class="pt-2">
                               <h4>LISTE DES RESSOURCES EXTERNES UTILISEES</h4>
                               <v-divider></v-divider>
                                 <br/>
                                 <div v-if="detailRapport.listeExterneMateriels.length > 0">
                                      <v-layout wrap>
                                   <v-flex md10>
                                       <v-chip outline text-color="primary" label color="primary" style="font-size:33px; width:100%">
                                           TOTAL TRAVAIL : {{totalExterniHT}}
                                       </v-chip>
                                   </v-flex>
                               </v-layout>
                               <!-- <v-layout row>
                                   <v-flex md10>
                                       <v-chip outline text-color="primary" label color="primary" style="font-size:33px; width:100%">
                                           TOTAL MONTANT DEPENSE: {{new Intl.NumberFormat('fr-Fr').format(MntToDepenExterne)}} FCFA
                                       </v-chip>
                                   </v-flex>
                               </v-layout> -->
                                 </div>
                               <v-layout row>
                                 <el-table :data="detailRapport.listeExterneMateriels" style="width: 100%">
                                   <el-table-column prop="type" label="Type" sortable></el-table-column>
                                   <el-table-column prop="libelle" label="Libelle"></el-table-column>
                                   <el-table-column prop="qte" label="Quantité " sortable></el-table-column>
                                   <el-table-column prop="unite" label="Unité" sortable></el-table-column>
                                   <el-table-column prop="heureDebut" label="Heure debut"></el-table-column>
                                   <el-table-column prop="heureFin" label="Heure fin"></el-table-column>                  
                                   <!-- <el-table-column prop="cout" label="Montant dépensé(FCFA)"></el-table-column> -->
                                 </el-table>
                               </v-layout>
                                <v-alert v-if="detailRapport.listeExterneMateriels.length == 0" class="elevation-1 subheading mb-1" color="warning" :value="true" icon="priority_high" outline>
                                     Informations non renseignées lors de l'enregistrement du rapport
                                 </v-alert>
                               <br />
                             </v-card>
                           </v-flex>
                         </v-layout>
                       </v-card-text>
                     </v-card>
                   </v-flex>
 
 
                   <v-flex xs12>
                     <v-alert :value="true" outline color="purple" icon="info">UTILISATION DES MATERIELS/ENGINS UTILISES</v-alert>
                     <v-card color class="mb-5">
                       <v-card-text>
                         <v-layout wrap>
                           <v-flex xs12>
                             <v-card class="pt-2">
                               <h4>LISTE DES MATERIELS/ENGINS UTILISES</h4>
                               <v-divider></v-divider>
                                 <br/>
                                 <div v-if="detailRapport.listeVehicules.length > 0">
                                      <v-layout wrap>
                                   <v-flex md10>
                                       <v-chip outline text-color="primary" label color="primary" style="font-size:33px; width:100%">
                                           TOTAL TRAVAIL : {{totalVehiHT}}
                                       </v-chip>
                                   </v-flex>
                                   <v-flex md10>
                                       <v-chip outline text-color="primary" label color="primary" style="font-size:33px; width:100%">
                                           TOTAL QUANTITE CARBURANT : {{ new Intl.NumberFormat('fr-Fr').format(totalQteCarb)}} LITRE(S)
                                       </v-chip>
                                   </v-flex>
                               </v-layout>
                               <!-- <v-layout row>
                                   <v-flex md10>
                                       <v-chip outline text-color="primary" label color="primary" style="font-size:33px; width:100%">
                                           TOTAL MONTANT DEPENSE: {{new Intl.NumberFormat('fr-Fr').format(totTTCFormatDepen)}} FCFA
                                       </v-chip>
                                   </v-flex>
                               </v-layout> -->
                                 </div>
                               <v-layout row>
                                 <el-table :data="detailRapport.listeVehicules" style="width: 100%">
                                     <el-table-column type="expand">
                                       <template slot-scope="props">
                                          <p>
                                           <b>Compteur début jour(km)</b>
                                           : {{ props.row.cptDjour }}
                                         </p>
                                          <p>
                                           <b>Compteur fin jour(km)</b>
                                           : {{ props.row.cptFjour }}
                                         </p>
                                         <p>
                                           <b>Prix (L)  du  carburant (FCFA)</b>
                                           : {{ props.row.cout }}
                                         </p>                                        
                                         <p>
                                           <b>Fournisseur</b>
                                           : {{ props.row.fournisseur }}
                                         </p>
                                         <p>
                                           <b>Description</b>
                                           : {{ props.row.description }}
                                         </p>
                                       </template>
                                   </el-table-column>
                                   <el-table-column prop="libelle" label="Matériel/Engin" sortable></el-table-column>
                                   <el-table-column prop="heureDebut" label="Heure début"></el-table-column>
                                   <el-table-column prop="heureFin" label="Heure fin"></el-table-column>
                                   <el-table-column prop="heurePause" label="Heure pause"></el-table-column>
                                   <el-table-column prop="heureTotal" label="Heure total"></el-table-column>
                                   <el-table-column prop="qte" label="Quantité Carburant(L)" sortable></el-table-column>
                                   <el-table-column prop="utilisation" label="Côut horaire(FCFA)"> </el-table-column>
                                   <!-- <el-table-column prop="total" label="Montant dépensé(FCFA)"></el-table-column> -->
                                   <!-- <el-table-column prop="fournisseur" label="Fournisseur"></el-table-column> -->
                                 </el-table>
                               </v-layout>
                                <v-alert v-if="detailRapport.listeVehicules.length == 0" class="elevation-1 subheading mb-1" color="warning" :value="true" icon="priority_high" outline>
                                     Informations non renseignées lors de l'enregistrement du rapport
                                 </v-alert>
                               <br />
                             </v-card>
                           </v-flex>
                         </v-layout>
                       </v-card-text>
                     </v-card>
                   </v-flex>
 
                   <v-flex xs12>
                     <v-alert :value="true" outline color="purple" icon="info">LISTE DES RESSOURCES TECHNIQUES</v-alert>
                     <v-card color class="mb-5">
                       <v-card-text>
                         <v-layout wrap>
                           <v-flex xs12>
                             <v-card class="pt-2">
                               <h4>LISTE DES RESSOURCES TECHNIQUES UTILISEES</h4>
                               <v-divider></v-divider>
                                <br/>
                                 <!-- <v-layout wrap>
                                   <v-flex md10>
                                       <v-chip outline text-color="primary" label color="primary" style="font-size:33px; width:100%">
                                           TOTAL HEURE TRAVAIL : {{totalOuvrHT}}
                                       </v-chip>
                                   </v-flex>
                               </v-layout>
                                <v-layout wrap v-if="this.totalOuvrHTHrSup != '00:00'">
                                   <v-flex md10>
                                       <v-chip outline text-color="primary" label color="primary" style="font-size:33px; width:100%">
                                           TOTAL HEURE SUPPLEMENTAIRE : {{totalOuvrHTHrSup}}
                                       </v-chip>
                                   </v-flex>
                               </v-layout> -->
                               <!-- <v-layout row>
                                   <v-flex md10>
                                       <v-chip outline text-color="primary" label color="primary" style="font-size:33px; width:100%">
                                            TOTAL MONTANT DEPENSE: {{new Intl.NumberFormat('fr-Fr').format(totTTCMtOuvreDepen)}} FCFA
                                       </v-chip>
                                   </v-flex>
                               </v-layout> -->
                               <!-- <v-layout row>
                                 <el-table
                                   :data="detailRapport.listeParticipants"
                                   style="width: 100%"
                                 >
                                   <el-table-column type="expand">
                                         <template slot-scope="props">
                                           <v-flex v-if=" props.row.heureSuppl != '00:00'">
                                           <p>
                                             <b>Heure supplémentaire</b>
                                             : {{ props.row.heureSuppl }}
                                           </p>
                                           <p>
                                             <b>Description heure supplémentaire</b>
                                             : {{props.row.descriptionSupp}}
                                           </p>
                                           </v-flex>
                                             <p>
                                             <b>Description</b>
                                             : {{ props.row.description }}
                                           </p>
                                         </template>
                                   </el-table-column>
                                   <el-table-column prop="nomPrenom" label="Nom & Prénoms" sortable></el-table-column>
                                   <el-table-column prop="travaux" label="Travaux" sortable></el-table-column>
                                   <el-table-column prop="heureDbt" label="Heure début" sortable></el-table-column>
                                   <el-table-column prop="heureFin" label="Heure fin" sortable></el-table-column>
                                   <el-table-column prop="heurePause" label="Heure pause" sortable></el-table-column>
                                   <el-table-column prop="heureIntem" label="Heure Intemperie" sortable></el-table-column>
                                   <el-table-column prop="heureTotal" label="Heure travail" sortable></el-table-column>
                                 </el-table>
                               </v-layout> -->
 
                                <v-layout row>
                                 <el-table
                                   :data="detailRapport.listeRessourtechnik"
                                   style="width: 100%"
                                 >
                                   <el-table-column prop="fonction" label="Fonction" sortable></el-table-column>
                                   <el-table-column prop="nombre" label="Nombre" sortable></el-table-column>
                                 </el-table>
                               </v-layout>
                                <v-alert v-if="detailRapport.listeRessourtechnik.length == 0" class="elevation-1 subheading mb-1" color="warning" :value="true" icon="priority_high" outline>
                                     Informations non renseignées lors de l'enregistrement du rapport
                                 </v-alert>
                               <br />
                             </v-card>
                           </v-flex>
                         </v-layout>
                       </v-card-text>
                     </v-card>
                   </v-flex>
                 </v-layout>
               </v-card>
             </v-flex>
           </v-layout>
         </v-card-text>
 
          <CoolLightBox :items="items" :index="index" @close="index = null">
             </CoolLightBox>
 
         <!-- VALIDATION -->
         <div style="flex: 1 1 auto;"></div>
       </v-card>
       <v-tooltip top>
         <v-btn
           class="mb-5 ml-5"
           v-if="verifValideChefProjet()"
           absolute
           slot="activator"
           dark
           fab
           large
           bottom
           right
           color="green"
           @click="dialogValidRapport = true"
         >
           <v-icon>done</v-icon>
         </v-btn>
         <span>Valider la demande chef projet</span>
       </v-tooltip>
 
 
       <v-tooltip top>
         <v-btn
           class="mb-5 ml-5"
           v-if="verifValideChefProjetGlobal()"
           absolute
           slot="activator"
           dark
           fab
           large
           bottom
           right
           color="green"
           @click="dialogValidRapportGbloabl = true"
         >
           <v-icon>done</v-icon>
         </v-btn>
         <span>Valider la demande chef projet</span>
       </v-tooltip>
       <v-tooltip top>
         <v-btn
           class="mb-5 ml-5"
           v-if="verifValideChefChant()"
           absolute
           slot="activator"
           dark
           fab
           large
           bottom
           right
           color="purple"
           @click="dialogValidRapport = true"
         >
           <v-icon>done</v-icon>
         </v-btn>
         <span>Valider la demande chef chantier</span>
       </v-tooltip>
 
       <v-tooltip top>
         <v-btn
           class="ml-5"
           style="margin-bottom: 140px;"
           absolute
           slot="activator"
           dark
           fab
           large
           bottom
           right
           color="orange"
           @click="imprimeJournalPDF()"
         >
           <v-icon>print</v-icon>
         </v-btn>
         <span>Imprimer le rapport</span>
       </v-tooltip>
 
 
     </v-dialog>
     <!-- DETAIL RAPPORT -->
 
 
     <!-- DETAIL LISTE TOUS LES  RAPPORTS -->
     <v-dialog
       v-model="dialogDetailListeRapport"
       fullscreen
       hide-overlay
       transition="dialog-bottom-transition"
       scrollable
     >
       <v-card tile>
         <v-toolbar card dark color="primary">
           <v-toolbar-title>LISTE DES RAPPORTS DE TRAVAUX {{libTrx}}</v-toolbar-title>
           <v-spacer></v-spacer>
           <v-btn icon dark @click.native="closeListeRapport()">
             <v-icon>close</v-icon>
           </v-btn>
         </v-toolbar>
         <v-card-text>
           <v-layout row>
             <v-flex xs12>
               <v-card color class="mb-5" flat>
                 <v-layout wrap>
                   <v-flex xs12>
                     <v-alert :value="true" outline color="purple" icon="info">TRAVAUX REALISES</v-alert>
                     <v-card color class="mb-5">
                       <v-card-text>
                         <v-layout wrap>
                           <v-flex xs12>
                             <v-card class="pt-2">
                               <h4>LISTE DES TACHES</h4>
                               <v-divider></v-divider>
                               <v-layout wrap>
                                 <v-flex xs12 mt-2>
                                   <el-table :data="listeRapports.listeTaches" style="width: 100%">
                                     <el-table-column prop="libTache" label="Libelle" sortable></el-table-column>
                                     <el-table-column v-if="soustraitant == 'OUI'" prop="soustraitant" label="Sous-traitant" sortable></el-table-column>
                                     <el-table-column prop="qte" label="Quantité"></el-table-column>
                                     <el-table-column prop="unite" label="Unité"></el-table-column>
                                     <el-table-column prop="libEtatTache" label="Etat"></el-table-column>
                                     <el-table-column prop="photos" label="Images">
                                       <template slot-scope="props">
                                         <v-tooltip bottom>
                                           <v-avatar
                                                   slot="activator"
                                                   v-for="(image, imageIndex) in props.row.photos"
                                                   :key="imageIndex"
                                                   @click="showDiapo(props.row.photos,imageIndex,image)"
                                                   :style="{ backgroundImage: 'url(' + image + ')' , cursor: 'pointer'}"
                                                   :tile=true
                                                   :size="50"
                                                   color="grey lighten-4"
                                                   class="mb-1 mr-1 elevation-3"
                                           >
                                               <img :src="image" alt="avatar">
                                           </v-avatar>
                                               Cliquez pour agrandir
                                           </v-tooltip>
                                       </template>
                                     </el-table-column>
                                   </el-table>
                                 </v-flex>
                               </v-layout>
                               <br />
                             </v-card>
                           </v-flex>
                         </v-layout>
                       </v-card-text>
                     </v-card>
                   </v-flex>
 
                   <v-flex xs12 v-if="listeRapports.listeReserves.length > 0">
                     <v-alert :value="true" outline color="purple" icon="info">TRAVAUX DE RESERVE</v-alert>
                     <v-card color class="mb-5">
                       <v-card-text>
                         <v-layout wrap>
                           <v-flex xs12>
                             <v-card class="pt-2">
                               <h4>LISTE DES TRAVAUX DE RESERVE</h4>
                               <v-divider></v-divider>
                               <v-layout row>
                                 <v-flex xs12>
                                   <data-tables
                                     :data="listeRapports.listeReserves"
                                     style="width:99%;"
                                   >
                                     <el-table-column type="expand">
                                       <template slot-scope="scope">
                                         <el-row>
                                           <el-col :span="8">
                                             <div class="grid-content bg-purple">
                                               <h2 class="mb-2">Commentaires:</h2>
                                               <div
                                                 class="mb-2"
                                                 v-for="(com, i) in scope.row.commentaires"
                                                 :key="i"
                                               >
                                                 <h3>Initiateur: {{com.initiateur}}</h3>
                                                 <h4>Date: {{com.dateCom}}</h4>
                                                 <h4>Description:</h4>
                                                 <div>{{com.description}}</div>
                                               </div>
                                             </div>
                                           </el-col>
 
                                           <el-col :span="14">
                                             <h2 class="mb-2">Photos:</h2>
                                             <p>
                                               <span
                                                 v-for="(photo, index) in scope.row.photos"
                                                 :key="index"
                                               >
                                                 <v-avatar
                                                   class="mr-2"
                                                   :tile="true"
                                                   size="140px"
                                                   height="120px"
                                                   color="grey lighten-4"
                                                 >
                                                   <img :src="photo" alt="avatar" />
                                                 </v-avatar>
                                               </span>
                                             </p>
                                           </el-col>
                                         </el-row>
                                       </template>
                                     </el-table-column>
 
                                     <el-table-column prop="idReserve" label="RESERVE" sortable>
                                       <template slot-scope="scope">R-{{scope.row.idReserve}}</template>
                                     </el-table-column>
                                     <el-table-column prop="dateC" label="DATE" sortable></el-table-column>
                                     <el-table-column prop="libTache" label="TACHE"></el-table-column>
                                     <el-table-column prop="libEtatRes" label="ETAT">
                                     </el-table-column>
                                     <el-table-column prop="initiateur" label="INITIATEUR"></el-table-column>
                                     <el-table-column prop="validateur" label="VALIDATEUR"></el-table-column>
                                     <el-table-column prop="cout" label="MONTANT"></el-table-column>
                                     <el-table-column prop="dureeRetard" label="DUREE RETARD (J)"></el-table-column>
                                   </data-tables>
                                 </v-flex>
                               </v-layout>
                               <br />
                             </v-card>
                           </v-flex>
                         </v-layout>
                       </v-card-text>
                     </v-card>
                   </v-flex>
 
                   <v-flex xs12>
                     <v-alert :value="true" outline color="purple" icon="info">VISITEUR CHANTIER</v-alert>
                     <v-card color class="mb-5">
                       <v-card-text>
                         <v-layout wrap>
                           <v-flex xs12>
                             <v-card class="pt-2">
                               <h4>LISTE DES VISITEURS</h4>
                               <v-divider></v-divider>
                               <v-layout row>
                                 <el-table :data="listeRapports.listeVisiteurs" style="width: 100%">
                                   <el-table-column prop="nomPrenom" label="Nom & Prénoms" sortable></el-table-column>
                                   <el-table-column prop="fonction" label="Fonction"></el-table-column>
                                   <el-table-column prop="dateVisite" label="Date de visite"></el-table-column>
                                   <el-table-column prop="HeureDbut" label="Heure debut"></el-table-column>
                                   <el-table-column prop="HeureFin" label="Heure fin"></el-table-column>
                                 </el-table>
                               </v-layout>
                                <v-alert v-if="listeRapports.listeVisiteurs.length == 0" class="elevation-1 subheading mb-1" color="warning" :value="true" icon="priority_high" outline>
                                     Informations non renseignées lors de l'enregistrement du rapport
                                 </v-alert>
                               <br />
                             </v-card>
                           </v-flex>
                         </v-layout>
                       </v-card-text>
                     </v-card>
                   </v-flex>
 
                   <v-flex xs12>
                     <v-alert :value="true" outline color="purple" icon="info">INCIDENTS</v-alert>
                     <v-card color class="mb-5">
                       <v-card-text>
                         <v-layout wrap>
                           <v-flex xs12>
                             <v-card class="pt-2">
                               <h4>LISTE DES INCIDENTS</h4>
                               <v-divider></v-divider>
                               <v-layout row>
                                 <el-table :data="detailRapport.incidents" style="width: 100%">
                                   <el-table-column type="expand">
                                     <template slot-scope="props">
                                       <p>
                                         <b>Description</b>
                                         : {{ props.row.description }}
                                       </p>
                                     </template>
                                   </el-table-column>
                                   <el-table-column prop="libelle" label="Libelle" sortable></el-table-column>
                                   <el-table-column prop="type" label="Type"></el-table-column>
                                   <el-table-column prop="qte" label="Nombre"></el-table-column>
                                   <el-table-column prop="date" label="Date et heure"></el-table-column>
                                 </el-table>
                               </v-layout>
                                <v-alert v-if="detailRapport.incidents.length == 0" class="elevation-1 subheading mb-1" color="warning" :value="true" icon="priority_high" outline>
                                     Informations non renseignées lors de l'enregistrement du rapport
                                 </v-alert>
                               <br />
                             </v-card>
                           </v-flex>
                         </v-layout>
                       </v-card-text>
                     </v-card>
                   </v-flex>
 
                   <v-flex xs12>
                     <v-alert :value="true" outline color="purple" icon="info">INVENTAIRE DU RESSOURCES </v-alert>
                     <v-card color class="mb-5">
                       <v-card-text>
                         <v-layout wrap>
                           <v-flex xs12>
                             <v-card class="pt-2">
                               <h4>LISTE DES RESSOURCES UTILISEES</h4>
                               <v-divider></v-divider>
                               <v-layout row>
                                 <el-table :data="listeRapports.listeMateriels" style="width: 100%">
                                   <el-table-column prop="libMat" label="Ressources" sortable></el-table-column>
                                   <el-table-column prop="qteMat" label="Quantité"></el-table-column>
                                   <el-table-column prop="unite" label="Unité"></el-table-column>
                                 </el-table>
                               </v-layout>
                                 <v-alert v-if="listeRapports.listeMateriels.length == 0" class="elevation-1 subheading mb-1" color="warning" :value="true" icon="priority_high" outline>
                                     Informations non renseignées lors de l'enregistrement du rapport
                                 </v-alert>
                               <br />
                             </v-card>
                           </v-flex>
                         </v-layout>
                       </v-card-text>
                     </v-card>
                   </v-flex>
 
 
                   <v-flex xs12>
                     <v-alert :value="true" outline color="purple" icon="info">INVENTAIRE DES RESSOURCES EXTERNES</v-alert>
                     <v-card color class="mb-5">
                       <v-card-text>
                         <v-layout wrap>
                           <v-flex xs12>
                             <v-card class="pt-2">
                               <h4>LISTE DES RESSOURCES EXTERNES UTILISEES</h4>
                               <v-divider></v-divider>
                                 <br/>
                                 <div v-if="detailRapport.listeExterneMateriels.length > 0">
                                      <v-layout wrap>
                                   <v-flex md10>
                                       <v-chip outline text-color="primary" label color="primary" style="font-size:33px; width:100%">
                                           TOTAL TRAVAIL : {{totalExterniHT}}
                                       </v-chip>
                                   </v-flex>
                               </v-layout>
                                 </div>
                               <v-layout row>
                                 <el-table :data="detailRapport.listeExterneMateriels" style="width: 100%">
                                   <el-table-column prop="type" label="Type" sortable></el-table-column>
                                   <el-table-column prop="libelle" label="Libelle"></el-table-column>
                                   <el-table-column prop="qte" label="Quantité " sortable></el-table-column>
                                   <el-table-column prop="unite" label="Unité" sortable></el-table-column>
                                   <el-table-column prop="heureDebut" label="Heure debut"></el-table-column>
                                   <el-table-column prop="heureFin" label="Heure fin"></el-table-column>                  
                                   <!-- <el-table-column prop="cout" label="Montant dépensé(FCFA)"></el-table-column> -->
                                 </el-table>
                               </v-layout>
                                <v-alert v-if="detailRapport.listeExterneMateriels.length == 0" class="elevation-1 subheading mb-1" color="warning" :value="true" icon="priority_high" outline>
                                     Informations non renseignées lors de l'enregistrement du rapport
                                 </v-alert>
                               <br />
                             </v-card>
                           </v-flex>
                         </v-layout>
                       </v-card-text>
                     </v-card>
                   </v-flex>
 
 
 
                   <v-flex xs12>
                     <v-alert :value="true" outline color="purple" icon="info">UTILISATION DES MATERIELS/ENGINS</v-alert>
                     <v-card color class="mb-5">
                       <v-card-text>
                         <v-layout wrap>
                           <v-flex xs12>
                             <v-card class="pt-2">
                               <h4>LISTE DES MATERIELS/ENGINS UTILISES</h4>
                               <v-divider></v-divider>
                                 <br/>
                                 <div v-if="detailRapport.listeVehicules.length != 0">
                                    <v-layout wrap>
                                   <v-flex md10>
                                       <v-chip outline text-color="primary" label color="primary" style="font-size:33px; width:100%">
                                           TOTAL TRAVAIL : {{this.secondsToHms(totalVehiHMinite)}}
                                       </v-chip>
                                   </v-flex>
                                   <v-flex md10>
                                       <v-chip outline text-color="primary" label color="primary" style="font-size:33px; width:100%">
                                           TOTAL QUANTITE CARBURANT : {{ new Intl.NumberFormat('fr-Fr').format(totalQteCarb)}} LITRE(S)
                                       </v-chip>
                                   </v-flex>
                               </v-layout>
                                 </div>
 
                               <v-layout row>
                                 <el-table :data="listeRapports.listeVehicules" style="width: 100%">
                                   <el-table-column type="expand">
                                       <template slot-scope="props">
                                          <p>
                                           <b>Compteur début jour(km)</b>
                                           : {{ props.row.cptDjour }}
                                         </p>
                                          <p>
                                           <b>Compteur fin jour(km)</b>
                                           : {{ props.row.cptFjour }}
                                         </p>
                                         <p>
                                           <b>Prix (L)  du  carburant (FCFA)</b>
                                           : {{ props.row.cout }}
                                         </p>                                        
                                         <p>
                                           <b>Fournisseur</b>
                                           : {{ props.row.fournisseur }}
                                         </p>
                                         <p>
                                           <b>Description</b>
                                           : {{ props.row.description }}
                                         </p>
                                       </template>
                                   </el-table-column>
                                   <el-table-column prop="libelle" label="Véhicule" sortable></el-table-column>
                                   <el-table-column prop="heureDebut" label="Heure début"></el-table-column>
                                   <el-table-column prop="heureFin" label="Heure fin"></el-table-column>
                                   <el-table-column prop="heurePause" label="Heure pause"></el-table-column>
                                   <el-table-column prop="heureTotal" label="Heure travail"></el-table-column>
                                   <el-table-column prop="qte" label="Quantité Carburant(L)" sortable></el-table-column>
                                   <el-table-column prop="utilisation" label="Côut horaire(FCFA)"> </el-table-column>                                  
                                 </el-table>
                               </v-layout>
                                 <v-alert v-if="detailRapport.listeVehicules.length == 0" class="elevation-1 subheading mb-1" color="warning" :value="true" icon="priority_high" outline>
                                     Informations non renseignées lors de l'enregistrement du rapport
                                 </v-alert>
                               <br />
                             </v-card>
                           </v-flex>
                         </v-layout>
                       </v-card-text>
                     </v-card>
                   </v-flex>
 
                   <v-flex xs12>
                     <v-alert :value="true" outline color="purple" icon="info">LISTE DES RESSOURCES TECHNIQUES</v-alert>
                     <v-card color class="mb-5">
                       <v-card-text>
                         <v-layout wrap>
                           <v-flex xs12>
                             <v-card class="pt-2">
                               <h4>LISTE DES RESSOURCES TECHNIQUES UTILISEES</h4>
                               <v-divider></v-divider>
                               <br/>
                                 <v-layout row>
                                 <el-table
                                   :data="detailRapport.listeRessourtechnik"
                                   style="width: 100%"
                                 >
                                   <el-table-column prop="fonction" label="Fonction" sortable></el-table-column>
                                   <el-table-column prop="nombre" label="Nombre" sortable></el-table-column>
                                 </el-table>
                               </v-layout>
                                <v-alert v-if="detailRapport.listeRessourtechnik.length == 0" class="elevation-1 subheading mb-1" color="warning" :value="true" icon="priority_high" outline>
                                     Informations non renseignées lors de l'enregistrement du rapport
                                 </v-alert>
                               <br />
                             </v-card>
                           </v-flex>
                         </v-layout>
                       </v-card-text>
                     </v-card>
                   </v-flex>
                 </v-layout>
               </v-card>
             </v-flex>
 
             <CoolLightBox
                     :items="items"
                     :index="index"
                     @close="index = null"
             >
 
             </CoolLightBox>
           </v-layout>
         </v-card-text>
 
           <!-- <v-tooltip top>
         <v-btn
           class="ml-5"
           style="margin-bottom: 140px;"
           absolute
           slot="activator"
           dark
           fab
           large
           bottom
           right
           color="orange"
           @click="imprimeALLJournalPDF()"
         >
           <v-icon>print</v-icon>
         </v-btn>
         <span>Imprimer le rapport</span>
       </v-tooltip> -->
 
        <v-flex>
             <el-popover ref="popImpresion" placement="top" width="180" trigger="hover">
                 <p>Veuillez choisir le mode d'impression ?</p>
                 <div style="text-align: center; margin: 0">
                     <el-button
                         type="success"
                         size="mini"
                         @click="imprimeALLJournalPDF('simple')"
                     >Simple</el-button>
                     <el-button
                         type="primary"
                         size="mini"
                         @click="imprimeALLJournalPDF('details')"
                     >
                     Detaillé
                     </el-button>
                 </div>
             </el-popover>
             <div>
                 <v-btn
                    class="ml-5"
                     style="margin-bottom: 140px;"
                     absolute
                     v-popover:popImpresion
                     slot="activator"
                     dark
                     fab
                     large
                     bottom
                     right
                     color="orange"
                 >
                     <v-icon dark>print</v-icon>
                 </v-btn>
             </div>
         </v-flex>
 
         <div style="flex: 1 1 auto;"></div>
       </v-card>
 
     </v-dialog>
     <!-- DETAIL LISTE RAPPORT -->
 
     <!--  VALIDATION CREATION RESERVE-->
     <!-- <v-dialog v-model="dialogAccord" max-width="600">
             <v-card>
                 <v-card-title class="headline">Voulez-vous confirmer la création d'une reserve ?</v-card-title>
                 <v-card-text>
                     En cliquant sur valider, Les responsables de projet,chantiers et travaux recevront une notification concernant les tâches à refaire. Après l'exécution des tâches selectionnées, ceux ci seront validées par le chef chantier et projet pour confirmer le rapport<br/>
                     <b>NB: La réserve ne pourra pas  être supprimée après validation</b>
                     <v-layout wrap>
                         <v-flex xs12>
                             <v-layout row>
                                 <v-flex md3  >
                                                         <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4"> <img :src="formReserve.images[0]" alt="avatar">
                                                         </v-avatar>
                                                         <v-layout row>
                                                             <input name="fileTache" type="file" style="display:none" ref="fileTache" accept="image/*" @change="onFileTachePicked"/>
                                                             <v-tooltip bottom>
                                                             <v-btn slot="activator" color="primary" class="white--text" required @click.native="$refs.fileTache.click()">
                                                                 Image 1<v-icon right dark>cloud_upload</v-icon>
                                                             </v-btn>
                                                              <span>Taille inférieur à 1024 ko</span>
                                                             </v-tooltip>
                                                         </v-layout>
                                                     </v-flex>
                                                      <v-flex md3  >
                                                         <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4"> <img :src="formReserve.images[1]" alt="avatar">
                                                         </v-avatar>
                                                         <v-layout row>
                                                             <input name="fileTache2" type="file" style="display:none" ref="fileTache2" accept="image/*" @change="onFileTachePicked2"/>
                                                             <v-tooltip bottom>
                                                             <v-btn  slot="activator" color="primary" class="white--text" required @click.native="$refs.fileTache2.click()">
                                                                 Image 2<v-icon right dark>cloud_upload</v-icon>
                                                             </v-btn>
                                                              <span>Taille inférieur à 1024 ko</span>
                                                             </v-tooltip>
                                                         </v-layout>
                                                     </v-flex>
                             </v-layout>
                         </v-flex>
 
                         <v-flex xs12>
                             <el-form  label-position="top" :inline="true"  class="demo-form-inline">
                                 <v-flex xs12 >
                                     <el-form-item style="width:100%" label="Description"  >
                                         <el-input style="width:100%"  type="textarea" :rows="6" placeholder="Description brève " v-model="descriptionReserve"></el-input>
                                     </el-form-item >
                                 </v-flex>
                             </el-form>
                         </v-flex>
                     </v-layout>
 
                 </v-card-text>
                 <v-card-actions>
                     <v-spacer></v-spacer>
                     <v-btn color="green darken-1" flat="flat" @click.native="dialogAccord = false">Annuler</v-btn>
                     <v-btn color="green darken-1" flat="flat" @click.native="createReserve()">Valider</v-btn>
                 </v-card-actions>
             </v-card>
     </v-dialog>-->
     <!--  VALIDATION  CREATION RESERVE-->
 
 
     
 
     <!--  MODAL ACCORD VALIDATION  -->
     <v-dialog v-model="dialogValidRapport" max-width="380">
       <v-card>
         <v-card-title class="headline">Voulez-vous validez le rapport ?</v-card-title>
         <v-card-text>En cliquant sur valider, en tant que responsable, vous confirmez que les travaux ont été correctement realisés.</v-card-text>
         <v-card-actions>
           <v-spacer></v-spacer>
           <v-btn
             color="green darken-1"
             flat="flat"
             @click.native="dialogValidRapport = false"
           >Annuler</v-btn>
           <v-btn color="green darken-1" flat="flat" @click.native="validerRapport()">Valider</v-btn>
         </v-card-actions>
       </v-card>
     </v-dialog>
     <!--  MODAL ACCORD VALIDATION-->
 
 
       <!--  MODAL ACCORD VALIDATION  RAPPORT GLOBAL -->
       <v-dialog v-model="dialogValidRapportGbloabl" max-width="380">
       <v-card>
         <v-card-title class="headline">Voulez-vous validez le rapport ?</v-card-title>
         <v-card-text>En cliquant sur valider, en tant que responsable, vous confirmez que les travaux ont été correctement realisés.</v-card-text>
         <v-card-actions>
           <v-spacer></v-spacer>
           <v-btn
             color="green darken-1"
             flat="flat"
             @click.native="dialogValidRapportGbloabl = false"
           >Annuler</v-btn>
           <v-btn color="green darken-1" flat="flat" @click.native="validerRapportGlobal()">Valider</v-btn>
         </v-card-actions>
       </v-card>
     </v-dialog>
     <!--  MODAL ACCORD VALIDATION-->
 
     <!-- AJOUTER RESERVE-->
     <AjoutReserve :tache="tacheSelect" :show="showAddReserve" @close=" closeAjoutReserve()"></AjoutReserve>
     <!-- AJOUTER RESERVE -->
 
   </div>   
 </template>
 
 <script>
 import Loading from "@/components/Loading";
 import AjoutReserve from "@/components/rapport/AjoutReserve";
 export default {
   components: { Loading, AjoutReserve },
   name: "ListeRapportTrx",
   props: {
     show: {
       type: Boolean
     },
     typeInterface: {
       type: Boolean,
       default: true
     },
     IddetailTravaux: {
       type: Number
     },
     type: {
       type: Number, //0=>chef travaux, 1=> chef chantier, 2=>chef projet
       default: 0
     },
     listeRapportTrx: {
       type: Array
     },
     libTrx: {
       type: String,
       default: null
     }
   },
   data() {
     return {
       //data general
       domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
       user: JSON.parse(sessionStorage.getItem("userInfo")),
       loading: false,
       dialogSupr: false,
       IdRapport:'',
      dialogListeRapport: false,
 
       listeContraTravaux: [],
       dialogDetailRapport: false,
       dialogDetailGblobalRapport: false,
       detailRapport: {
         listeReserves: [],
         listeVisiteurs: [],
         incidents: [],
         listeMateriels: [],
         listeVehicules: [],
         listeExterneMateriels: [],
         listeRessourtechnik: []
       },
       disabledBtnReserve: true,
       multipleSelection: [],
       RapportTrx: [],
       items: [],
        index: null,
       dialogAccord: false,
       descriptionReserve: "",
 
       // VEHICULE
       totalQteCarb : 0,
       totTTCFormatDepen : 0,
       totalVehiHT:'',
       totalVehiHMinite :0,
 
       // MATERIEL EXRTERNE
       MntToDepenExterne: 0,
       totalExterniHT:'',
       soustraitant: '',
 
       //OUVRIER
       totalOuvrHT:'',
       totTTCMtOuvreDepen: 0,
       totalOuvrHTMinute: 0,
       totalOuvrHTMinuteSup: 0,
       totalOuvrHTHrSup: 0,
 
 
       //FILTRE
        listeProjet:[],
        listeChantier:[],
        BesoinsList: [],
        projetS: '',
        chantierS: '',
       travauxS: '',
       dialogValidRapport: false,
       dialogValidRapportGbloabl: false,
 
       //LISTE RAPPORTS
       dialogDetailListeRapport: false,
       listeTravaux:[],
       
       listeRapports: {
         listeTaches: [],
         listeReserves: [],
         listeVisiteurs: [],
         listeParticipants: [],
         listeMateriels: [],
         listeVehicules: [],
         incidents:[],
         listeExterneMateriels: [],
         listeRessourtechnik:[]
       },
       formReserve: {
         images: []
       },
       fichierImage: [],
       idTacheSelect: null,
       tacheSelect: null,
       //RESERVE
       showAddReserve: false
     };
   },
   watch: {
      show : function(newValue, oldvalue){
                 if(newValue == true){
                     //this.oldListTravaux = this.listeTrx;
                     this.typeInterface = false
                 }
               this.loadChantier();
                 this.dialogListeRapport = newValue
             },
     listeRapportTrx : function(newValue, oldvalue){
       this.RapportTrx = this.listeRapportTrx;
       
 
     },
   },
 
   methods: {
 
      //FILTRE
           loadProjet ()
           {
             this.listeChantier.splice(0)
             this.chantierS = null
               let url = this.domaine + 'projet/index-projet-all'
 
               this.loading = true
               this.$http.get(url).then(response => {
                   this.loading = false
                       this.listeProjet = response.body.projet
               },errRep=>{
                    this.loading = false
                   this.$message.error("Une erreur est survenue lors du chargement de la liste des projets")
               })
           },
            deleteJournal () {
               let url = this.domaine + 'journal/delete/' + this.IdRapport.idRapport
               this.$http.get(url).then(response => {
                 if (response.body) {
                   if (response.body.code === 1) {
                     this.$notify({
                       title: 'SUPPRESSION',
                       message: "Le rapport à été supprimé avec succès.",
                       type: 'success',
                       position: 'top-center'
                     })
                     // this.emit('dialogListeRapport')
                     this.dialogSupr = false
                     this.$emit('close');
                   } else if(response.body.code === -2) {
                     this.$notify.error({
                       title: 'SUPPRESSION IMPOSSIBLE',
                       message: 'Impossible de supprimer ce rapport.',
                       position: 'top-center'
                     })
                   } else {
                     this.$notify.error({
                       title: 'SUPPRESSION ECHOUE',
                       message: 'La suppression de rapport à échoué.',
                       position: 'top-center'
                     })
                   }
                 }
               })
             },
           showDiapo(images, ind,image){
             this.items = images
             this.index = ind;
             },
           loadChantier ()
             {
               if( (this.projetS == null || this.projetS == "undefined" || this.projetS == "")   ){
                  this.RapportTrx = this.listeRapportTrx;
                 return ;
               }
               this.loading =  true
               let url = this.domaine + 'projet/'+ this.projetS +'/index/chantier'
               this.$http.get(url).then(response => {
                   this.loading = false
                   this.listeChantier = response.body.chantier
               },errRep=>{
                    this.loading = false
                   this.$message.error("Une erreur est survenue lors du chargement de la liste du chntier")
               })
           },
            filtrerChantier(){
               //this.oldListTravaux = this.listeTrx;
               let idChant = this.chantierS;
               this.RapportTrx = this.listeRapportTrx.filter(function (item) {
               return item.idChant == idChant
               })
             },
             clearSelect(){
             //this.listeTrx = this.oldListTravaux;
             this.projetS= '';
             this.chantierS= '';
             this.listeChantier.splice(0)
           },
 
     //RESERVE
     //reserve
     closeAjoutReserve() {
       this.showAddReserve = false;
       this.loadDetailRapport(this.detailRapport);
     },
     closeListeRapport(){
       this.dialogDetailListeRapport = false;
       this.totTTCFormatDepen = 0
       this.totalQteCarb =0
       this.totalVehiHT = ''
       this.totalOuvrHT = ''
       this.totalOuvrHTHrSup = ''
       this.MntToDepenExterne = 0
       this.totalExterniHT = 0
     },
 
     showDialogReserve(itemTache) {
       this.tacheSelect = itemTache;
       this.showAddReserve = true;
     },
 
     verifValideChefChant() {
       //   if( this.type != 0 && this.detailRapport.etatRapport != 3 &&  (this.detailRapport.etatRapport != 1 && this.type != 2) && (this.detailRapport.etatRapport != 2 && this.type != 2)) {
       //       return true;
       //   }
       if (this.type == 1 && this.detailRapport.etatRapport == 0) {
         return true;
       } else {
         return false;
       }
     },
     verifValideChefProjet() {
       if (this.type == 2 && this.detailRapport.etatRapport == 1) {
         return true;
       } else {
         return false;
       }
     },
     verifValideChefProjetGlobal() {
       console.log('global',this.type)
       console.log('chefProjetGlobal',this.type)
       console.log('etat',this.detailRapport.etatRapport)
       if (this.type == 2 && this.detailRapport.etatRapport == 0) {
         return true;
       } else {
         return false;
       }
     },
     verifBoutReserve() {
       if (this.type == 1 && this.detailRapport.listeReserves.length == 0) {
         //chef chantier
         return this.verifValideChefChant();
       } else if (
         this.type == 2 &&
         this.detailRapport.listeReserves.length == 0
       ) {
         //chef projet
         return this.verifValideChefProjet();
       }
     },
     validerRapport() {
       this.loading = true;
       let url = "";
       if (this.type == 2) {
         url =
           this.domaine +
           "journal/respoprojet/valider/" +
           this.detailRapport.idRapport;
       } else if (this.type == 1) {
         url =
           this.domaine +
           "journal/respochantier/valider/" +
           this.detailRapport.idRapport;
       } else {
         return;
       }
 
       let data = new FormData();
       data.append("idUser", this.user.id);
 
       this.$http.post(url, data).then(
         response => {
           this.dialogValidRapport = false;
           this.dialogDetailRapport = false;
           this.loading = false;
           this.$notify({
             title: "VALIDATION RAPPORT",
             message:
               "Rapport validé",
             type: "success",
             position: "top-center",
             duration: 7000
           });
           this.$emit("reloadListeRapport");
         },
         error => {
           this.loading = false;
           this.$message.error("Echec lors de la validation rapport");
         }
       );
     },
     validerRapportGlobal() {
       this.loading = true;
       let url = "";
       if (this.type == 2) {
         url =
           this.domaine +
          //  "journal/global/respoprojet/valider/" +
           "journal/respoprojet/valider/" +
           this.detailRapport.idRapport;
       } else if (this.type == 1) {
         url =
           this.domaine +
          //  "journal/global/respochantier/valider/" +
           "journal/respochantier/valider/" +
           this.detailRapport.idRapport;
       } else {
         return;
       }
 
       let data = new FormData();
       data.append("idUser", this.user.id);
 
       this.$http.post(url, data).then(
         response => {
           this.dialogValidRapportGbloabl = false;
           this.dialogDetailRapport = false;
           this.loading = false;
           this.$notify({
             title: "VALIDATION DU RAPPORT GLOBAL",
             message:
               "Rapport validé",
             type: "success",
             position: "top-center",
             duration: 7000
           });
           this.$emit("reloadListeRapport");
         },
         error => {
           this.loading = false;
           this.$message.error("Echec lors de la validation rapport");
         }
       );
     },
     createReserve() {
       this.loading = true;
       let url = this.domaine + "reserve/new";
       let data = new FormData();
       //enregistrement des taches
       //data.append("tableTacheRapport", JSON.stringify(this.detailRapport.listeTaches) );
 
       data.append("idTache", JSON.stringify(this.idTacheSelect));
 
       data.append("description", this.descriptionReserve);
       data.append("idUser", this.user.id);
       data.append("idRapport", this.detailRapport.idRapport);
       if (this.fichierImage.length > 0) {
         this.fichierImage.forEach(file => {
           data.append("fichierImage[]", file, file[name]);
         }, this);
       }
 
       this.$http.post(url, data).then(
         resp => {
           this.loading = false;
           this.dialogAccord = false;
           this.$notify({
             title: "Reserve",
             message: "Reserve chantier enregistré",
             type: "success",
             position: "top-right",
             duration: 7000
           });
 
           this.loadDetailRapport(this.detailRapport);
           this.formReserve.images.splice(0);
 
           $this.$emit("reloadListeTrx");
           //this.dialogAccord = false
           //this.dialogRapport = false
         },
         resp => {
           this.loading = false;
           this.$message.error("Erreur lors de l'enregistrement d'une reserve");
         }
       );
     },
     handleSelectionChange(val) {
       this.multipleSelection = val;
       if (this.multipleSelection.length === 0) {
         this.disabledBtnReserve = true;
       } else {
         this.disabledBtnReserve = false;
       }
     },
     loadDetailGlobalRapport(item) {
       this.loading = true;
       let url = this.domaine + "journal/" + item.idRapport;
       this.$http.get(url).then(
         response => {
           this.detailRapport = response.body.journal;
           this.soustraitant = response.body.journal.soustraiter
           //information pour les vehicules
           this.totalQteCarb = response.body.journal.QteToCarbur;
           this.totTTCFormatDepen = response.body.journal.MntToDepen;
           this.totalVehiHT = response.body.journal.ToTalHeur;
 
           // information pour materiel externe
           this.MntToDepenExterne = response.body.journal.MntToDepenExterne;
           this.totalExterniHT = response.body.journal.ToTalHeurExterne;
 
           //information pour les ouvriers
           this.totalOuvrHT =  response.body.journal.HeuOuvreToTl;
           this.totalOuvrHTHrSup =  response.body.journal.HeuOuvreToTlHrSup;
 
           this.totTTCMtOuvreDepen = response.body.journal.MntOuvreToTl;
 
           this.dialogDetailGblobalRapport = true;
           this.loading = false;
         },
         error => {
           this.loading = false;
           this.$message.error("Echec lors du chargement detail du Journal");
         }
       );
     },
     loadDetailRapport(item) {
       this.loading = true;
       let url = this.domaine + "journal/" + item.idRapport;
       this.$http.get(url).then(
         response => {
           this.detailRapport = response.body.journal;
           console.log('rjejer',this.detailRapport)
           this.soustraitant = response.body.journal.soustraiter
           //information pour les vehicules
           this.totalQteCarb = response.body.journal.QteToCarbur;
           this.totTTCFormatDepen = response.body.journal.MntToDepen;
           this.totalVehiHT = response.body.journal.ToTalHeur;
 
           // information pour materiel externe
           this.MntToDepenExterne = response.body.journal.MntToDepenExterne;
           this.totalExterniHT = response.body.journal.ToTalHeurExterne;
 
 
           //information pour les ouvriers
           this.totalOuvrHT =  response.body.journal.HeuOuvreToTl;
           this.totalOuvrHTHrSup =  response.body.journal.HeuOuvreToTlHrSup;
 
           this.totTTCMtOuvreDepen = response.body.journal.MntOuvreToTl;
 
           this.dialogDetailRapport = true;
           this.loading = false;
         },
         error => {
           this.loading = false;
           this.$message.error("Echec lors du chargement detail du Journal");
         }
       );
     },
       closeDialog(){
       this.$emit('close');
     },
     loadListerapports() {
       //this.loading = true;
       this.listeRapports.listeTaches.splice(0);
       this.listeRapports.listeReserves.splice(0);
       this.listeRapports.listeVisiteurs.splice(0);
       this.listeRapports.listeParticipants.splice(0);
       this.listeRapports.listeMateriels.splice(0);
       this.listeRapports.listeVehicules.splice(0);
       this.listeRapports.listeRessourtechnik.splice(0);
      //  this.listeRapports.listeExterneMateriels.splice(0);
       this.listeRapports.incidents.splice(0);
 
 
       // this.totalVehiHT = ''
       // this.totalOuvrHT = ''
        this.totalOuvrHTMinute= 0,
        this.totalOuvrHTMinuteSup = 0,
       this.totalVehiHMinite=0,
       // this.IddetailTravaux = this.projetS
 
       this.listeRapportTrx.forEach(item => {
         let url = this.domaine + "journal/" + item.idRapport;
         this.$http.get(url).then(
           response => {
          
             console.log('alons',this.soustraitant )
             this.listeRapports.listeTaches.push(
               ...response.body.journal.listeTaches
             );
             this.listeRapports.listeReserves.push(
               ...response.body.journal.listeReserves
             );
             this.listeRapports.listeVisiteurs.push(
               ...response.body.journal.listeVisiteurs
             );
             this.listeRapports.listeParticipants.push(
               ...response.body.journal.listeParticipants,
             );
             if(response.body.journal.listeMateriels){
               this.listeRapports.listeMateriels.push(
               ...response.body.journal.listeMateriels
             );
             }
             this.listeRapports.listeVehicules.push(
                   ...response.body.journal.listeVehicules,
 
               );
             this.listeRapports.incidents.push(
               ...response.body.journal.incidents
             );
 
              this.listeRapports.listeRessourtechnik.push(
               ...response.body.journal.listeRessourtechnik
             );
             this.listeRapports.listeExterneMateriels.push(
               ...response.body.journal.listeMaterielsExtern
             );
             
              //information pour les vehicules
               this.totalQteCarb +=response.body.journal.QteToCarbur,
               this.totTTCFormatDepen += response.body.journal.MntToDepen,
               this.totalVehiHMinite += response.body.journal.ToTalHeurMinute
 
               this.typeInterface = true
                 //information pour les ouvriers
               this.totalOuvrHTMinute +=  response.body.journal.HeuOuvreToTlMinute,
               this.totalOuvrHTMinuteSup += response.body.journal.HeuOuvreToTlMinuteSup,
               this.totTTCMtOuvreDepen += response.body.journal.MntOuvreToTl
 
 
           },
           error => {
             this.loading = false;
             this.$message.error("Echec lors du chargement detail du Journal");
           }
         );
       },
       this);
 
 
       this.loading = false;
       this.dialogDetailListeRapport = true;
     },
       secondsToHms(d) {
           d = Number(d);
           var h = Math.floor(d / 60);
           var m = Math.floor(d % 60);
           var hDisplay = h > 0 ? h :'00';
           var mDisplay = m > 0 ? m :'00';
           return hDisplay+':'+ mDisplay;
       },
     onFileTachePicked(event) {
       this.formReserve.images.splice(0, 1);
       this.fichierImage.splice(0, 1);
       const files = event.target.files;
       let filename = files[0].name;
       if (filename.lastIndexOf(".") <= 0) {
         return alert("Veuillez selectionner un  format de fichier valide ");
       }
       if (files[0].size > 1048576) {
         this.$message.error("La taille du fichier est supérieur à 1024 ko");
         return;
       }
 
       const fileReader = new FileReader();
       fileReader.addEventListener("load", () => {
         this.formReserve.images.push(fileReader.result);
       });
 
       fileReader.readAsDataURL(files[0]);
 
       this.fichierImage.push(files[0]);
     },
 
     onFileTachePicked2(event) {
       this.formReserve.images.splice(1, 1);
       this.fichierImage.splice(1, 1);
       const files = event.target.files;
       let filename = files[0].name;
       if (filename.lastIndexOf(".") <= 0) {
         return alert("Veuillez selectionner un  format de fichier valide ");
       }
       if (files[0].size > 1048576) {
         this.$message.error("La taille du fichier est supérieur à 1024 ko");
         return;
       }
 
       const fileReader = new FileReader();
       fileReader.addEventListener("load", () => {
         this.formReserve.images.push(fileReader.result);
       });
 
       fileReader.readAsDataURL(files[0]);
       this.fichierImage.push(files[0]);
     },
 
     //impression rapports
     imprimeJournalPDF() {
       let url =
         this.domaine + "journal/imprimerPDF/" + this.detailRapport.idRapport+'/'+this.user.id;
       window.open(url);
     }
     ,
      //impression de tous les rapports
     imprimeALLJournalPDF(format) {
       let url =
         this.domaine + "journal/imprimer_AllPDF/" + this.IddetailTravaux+'/'+format+'/'+this.user.id;
       window.open(url);
     }
   },
 
   mounted() {
     // this.loadProjet();
     this.loadChantier();
     this.clearSelect();
   }
 
 };
 </script>


// WEBPACK FOOTER //
// src/components/rapport/ListeRapportTrx.vue